
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customs-regulations",
      function () {
        return require("private-next-pages/customs-regulations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customs-regulations"])
      });
    }
  